jQuery( function ( $ ) {

    // TODO:
    // add live region

    $( 'section.slider_banner' ).each( function () {
        let $section = $(this);
        let $slider = $( '.slider', $section );
        let $slides = $( '.slide', $slider );
        let $imgs = $( '> img', $section );

        if ( $slides.length < 2 ) {
            return;
        }

        $slider.on( 'beforeChange', function ( e, slick, current, next ) {
            // set_counter_position( slick, next );
            $imgs.eq( next ).addClass( 'd-block' );
            window.requestAnimationFrame( () => {
                $imgs.eq( current ).removeClass( 'o-100' );
                $imgs.eq( next ).addClass( 'o-100' );
            });
        });

        $slider.on( 'init afterChange', function ( e, slick, index = null ) {
            // slick calls a11y functionality before afterChange
            // we want to remove the slide's tabindex, so we need to disable the a11y option and call it's core function ourselves
            slick.initADA();
            slick.$slides.filter( '.slick-active' ).removeAttr( 'tabindex' );
            if ( slick.$dots ?? null ) {
                slick.$dots.attr( 'aria-hidden', 'true' ).find( 'button' ).attr( 'tabindex', '-1' );
            }
        });

        $slider.slick({
            dots: false,
            appendDots: $( '> div.container', this ),
            customPaging: function( slider, i ) {
                return $('<button type="button" />').html( $( '<span />' ).addClass( 'sr-only' ).text( i + 1 ) );
            },
            arrows: true,
            prevArrow: $( 'button.slick-previous', this ),
            nextArrow: $( 'button.slick-next', this ),
            fade: true,
            adaptiveHeight: true,
            draggable: false,
            accessibility: false,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: ThemeJS.Variables.Screen_Sizes.lg,
                    settings: {
                        dots: true,
                    },
                },
            ],
        });

    });

});